module.exports = __webpack_public_path__ + "img/gongzhonghao.a496b6b1.png";